import { endOfDay, endOfMonth, endOfWeek, startOfDay, startOfMonth, startOfWeek } from "date-fns";

import DateRange from "@mapmycustomers/shared/types/range/DateRange";

import { WEEK_OPTIONS } from "../consts";
import UserLocationDatePeriod from "../enums/UserLocationDatePeriod";

const getDateRangeForSelectedDatePeriod = (
  period: UserLocationDatePeriod,
  anchor: Date
): DateRange => {
  switch (period) {
    case UserLocationDatePeriod.Day:
      return { endDate: endOfDay(anchor), startDate: startOfDay(anchor) };
    case UserLocationDatePeriod.Month:
      return { endDate: endOfMonth(anchor), startDate: startOfMonth(anchor) };
    case UserLocationDatePeriod.Week:
      return {
        endDate: endOfWeek(anchor, WEEK_OPTIONS),
        startDate: startOfWeek(anchor, WEEK_OPTIONS),
      };
  }
};

export default getDateRangeForSelectedDatePeriod;
